<template>
  <div class="rui-loading" :class="componentCSS">
    <rui-overlay v-if="fill" opaque />
    <div class="rui-loading__wrapper">
      <div class="rui-loading__spinner">
        <div />
        <div />
        <div />
        <div />
      </div>
      <div v-if="$slots.default || text">
        <!-- @slot Alternative to the `text` prop for more complex content -->
        <slot>{{ text }}</slot>
      </div>
    </div>
  </div>
</template>

<script>
import RuiOverlay from '../Utils/Overlay/Overlay.vue'

/**
 * Displays a notification about something loading.
 *
 * @preset Default { }
 * @preset With text { "props": { "text": "Loading comments..." } }
 * @propsGroup Display [fill, relative, centered]
 * @propsGroup Content [text]
 */
export default {
  name: 'RuiLoading',
  components: { RuiOverlay },
  props: {
    /** Custom text to display */
    text: { required: false, type: String, default: null },
    /** Whether to fill the whole page */
    fill: { required: false, type: Boolean, default: false },
    /**
     * Whether to fill only the parent selector. Has no effect **without** `fill`. Make sure the parent is large enough
     * **and has the `position: relative` style**
     */
    relative: { required: false, type: Boolean, default: false },
    /** Whether to center text content. Has no effect with `fill`. */
    centered: { required: false, type: Boolean, default: false },
  },
  computed: {
    componentCSS () {
      return [
        this.fill && 'rui-loading--fill',
        this.relative && 'rui-loading--relative',
        this.centered && 'rui-loading--centered',
      ]
    },
  },
}
</script>
